module.exports = __webpack_public_path__ + "static/media/Brommer.a405b1c3.mp3";